module.exports = __webpack_public_path__ + "static/duo-man-89c4a888be3d1accc201a48c65128b8a.svg";